export enum REG_KEYS {
  ACCOUNT_HOLDER = 'accountHolder',
  ACCOUNT_NUMBER = 'accountNumber',
  IFSC_CODE = 'ifscCode',
  BANK_NAME = 'bankName',
  ACCOUNT_HOLDER_SELF_SERVE = 'accountHolder_selfServe',
  ACCOUNT_NUMBER_SELF_SERVE = 'accountNumber_selfServe',
  IFSC_CODE_SELF_SERVE = 'ifscCode_selfServe',
  BANK_NAME_SELF_SERVE = 'bankName_selfServe',
  ORG_TYPE = 'orgType',
  OWNER_PAN_NAME = 'ownerPanName',
  COMPANY_PAN_NAME = 'companyPanName',
  COMPANY_PAN = 'companyPan',
  WEBSITE = 'website',
  APP_LINK = 'AppLink',
  ADDRESS = 'address',
  CITY = 'city',
  COUNTRY = 'country',
  STATE = 'state',
  POSTAL_CODE = 'postalCode',
  CPV_ADDRESS_CONFIRMATION = 'cpvAddressConfirmation',
}

export enum OB_STATUS {
  UNAPPROVED = 0,
  APPROVED = 1,
  REJECTED = 2,
  VERIFIED = 5,
  NA = 4,
  DELETED = 6,
}
